import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { TabPanel, TabView } from "primereact/tabview";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Menu } from "primereact/menu";

// ------------------ COMPONENTES DE BASE--------------------------------
import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getDatesProduccionOutHours } from "../../../../Base/Services/Moment/Luxon";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import ModalFull from "../../../../Base/Components/Dialog/ModalFull";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../../Base/Services/Moment/Luxon";
import CalendarioOperativo from "../../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API--------------------------------
import { getListadoOrdenes, getListadoDetalleOrdenes } from "../../../../API/Compras/Ordenes/OrdenesComprasRequests";
import { getRequisasDetalle } from "../../../../API/Compras/RequisiscionCompras/PurchaseRequestDetails";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import OrdenesComprasCrud from "./CrudOrdenesCompras/OrdenesComprasCrud";
import CrudRequisa from "../Requisas/CrudRequisa/CrudRequisa";
import OrdenesComprasReporte1 from "./Reporte/OrdenesComprasReporte1";

const OrdenesComprasScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const toast = useRef(null);
  const menuImprimir = useRef(null);
  const [permisoCostos, setpermisoCostos] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [loading, setLoading] = useState(false);
  const [dataOrdenes, setDataOrdenes] = useState([]);
  const [dataDetalle, setDataDetalle] = useState([]);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [requisaDialog, setRequisaDialog] = useState(false);
  const [ordenDialog, setOrdenDialog] = useState(false);
  const [orderToShow, setOrderToShow] = useState(null);
  const [requisaToShow, setRequisaToShow] = useState(null);
  const [detalles, setDetalles] = useState([]);
  const [habilitar, setHabilitar] = useState(false);
  const [habilitar1, setHabilitar1] = useState(false);
  const [showReporte, setShowReporte] = useState(false);
  const [Languaje, setLanguaje] = useState('es');

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
      return;
    }
    setLoading(true);
    const f = getDatesProduccionOutHours(dates);
    const t = await getListadoOrdenes(f);
    const d = await getListadoDetalleOrdenes(f);
    setDataOrdenes(t);
    setDataDetalle(d.filter(i =>i?.IdStatus !== 15));
    setLoading(false);
  };

  const columnOrdenes = [
    {
      field: "IdPurchaseOrder",
      header: "ID",
      headerEn:"ID",
      className: "XXsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
    },
    {
      // FECHA CREADO
      field: "OrderDate",
      header: "Fecha Creado",
      headerEn: "Date Create",
      className: "small",
      alignFrozen: "left",
      frozen: "frozen",
      Format: "DateTime",
    },
    {
      // ESTADO
      field: "Estado",
      header: "Estado",
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
      hidden: false, // Columna Oculta
    },
    {
      // NUMERO ORDEN
      field: "PurchaseOrder",
      header: "No. Orden",
      headerEn: "No. Orden",
      className: "small",
      frozen: "frozen",
      alignFrozen: "left",
      Sumary: "count",
      align: "center",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        OrdenC(data.PurchaseOrder);
      },
    },
    {
      // PROVEEDOR
      field: "Expr1",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "XXlarge",
      Format: "LongText",
    },
    {
      // AGENTE
      field: "UserNameAgente",
      header: "Agente",
      headerEn: "Agente",
      className: "large",
    },
    {
      // TERMINOS
      field: "TerminoPago",
      header: "Términos de Pago",
      headerEn: "Payment Terms",
      className: "large",
    },
    {
      // TERMINOS Inco
      field: "TerminoInco",
      header: "Términos Inco",
      headerEn: "Inco Term",
      className: "large",
    },
    {
      // CLIENTE ***********
      field: "CustomerName",
      header: "Cliente",
      headerEn: "Customer",
      className: "large",
    },
    {
      // MONEDA
      field: "CurrencySymbol",
      header: "Moneda",
      headerEn: "Currency",
      className: "small",
      align: "center",
    },
    {
      // TIPO COMPRA
      field: "Type",
      headerEn: "Purchase Type",
      header: "Tipo Compra",
      className: "medium",
    },
    {
      // AREA SOLICITA
      field: "Area",
      header: "Área",
      headerEn: "Area",
      className: "Xlarge",
    },
    {
      // ENTREGAR A
      field: "Address",
      header: "Entregar a",
      headerEn: "Deliver To",
      className: "Xlarge",
    },
    {
      // Comentarios
      field: "Description",
      header: "Comentario",
      headerEn: "Comment",
      className: "Xlarge",
    },
    {
      // Fecha desde
      field: "RequiredDate",
      header: "Fecha Desde",
      headerEn: "Date From",
      className: "small",
      Format: "Date",
    },
    {
      // Fecha hasta
      field: "RequiredDateH",
      header: "Fecha Hasta",
      headerEn: "Date Until",
      className: "small",
      Format: "Date",
    },
    {
      field: "SubTotal",
      header: "SubTotal",
      className: "small",
      frozen: "frozen",
      alignFrozen: "right",
      Sumary: "sum",
      Format: "Currency",
      hidden: permisoCostos,
    },
    // {
    //   field: "Freights",
    //   header: "Fletes",
    //   headerEn: "Freights",
    //   className: "Xsmall",
    //   frozen: "frozen",
    //   alignFrozen: "right",
    //   hidden: permisoCostos,
    //   Sumary: "sum",
    //   Format: "Currency",
    // },
    {
      field: "TAX",
      header: "ISV",
      headereN: "TAX",
      className: "Xsmall",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
      Sumary: "sum",
      Format: "Currency",
    },
    {
      field: "ISV18",
      header: "ISV 18%",
      headereN: "TAX18%",
      className: "Xsmall",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
      Sumary: "sum",
      Format: "Currency",
    },
    // {
    //   field: "Otros",
    //   header: "Otros",
    //   headerEn: "Others",
    //   className: "Xsmall",
    //   frozen: "frozen",
    //   alignFrozen: "right",
    //   hidden: permisoCostos,
    //   Sumary: "sum",
    //   Format: "Currency",
    // },
    {
      field: "Discount",
      header: "Descuento",
      headerEn: "Discount",
      className: "Xsmall",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
      Sumary: "sum",
      Format: "Currency",
    },
    {
      field: "Total",
      header: "Total",
      className: "small",
      frozen: "frozen",
      alignFrozen: "right",
      Sumary: "sum",
      Format: "Currency",
      hidden: permisoCostos,
    },
  ];

  const columnDetalle = [
    {
      field: "IdPurchaseOrderDetail",
      header: "ID",
      headerEn:"ID",
      className: "XXsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
    },
    {
      // FECHA CREADO
      field: "FechaCreado",
      header: "Fecha Creado",
      headerEn: "Date Created",
      className: "small",
      alignFrozen: "left",
      frozen: "frozen",
      Format: "DateTime",
    },
    {
      // ESTADO
      field: "Estado",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.Estado }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {
      // NUMERO ORDEN
      field: "PurchaseOrder",
      header: "No. Orden",
      className: "small",
      Format: "Modal",
      Sumary: "count",
      frozen: "frozen",
      alignFrozen: "left",
      onCellDoubleClicked: ({ data }) => {
        OrdenC(data.PurchaseOrder);
      },
    },
    {
      // CODIGO PRODUCTO
      field: "CodigoProducto",
      header: "Código",
      headerEn: "Product",
      className: "Xsmall",
    },
    {
      // NOMBRE PRODUCTO
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "Xlarge",
    },
    {
      // Comentarios
      field: "Description",
      header: "Descripción Producto",
      headerEn: "Product Description",
      className: "Xlarge",
    },
    {
      // REQUISA
      field: "PurchaseRequest",
      header: "Requisa Compras",
      headerEn: "Purchase Request",
      className: "small",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        RequisaC(data.PurchaseRequest);
      },
    },
    {
      // PROVEEDOR
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "Xlarge",
    },
    {
      // AREA SOLICITA
      field: "Area",
      header: "Área",
      headerEn: "Area",
      className: "medium",
    },
    {
      // CATEGORIA
      field: "NombreCategoria",
      header: "TipoProducto",
      headerEn: "Category",
      className: "small",
    },
    {
      // SUBCATEGORIA
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      // SUBCATEGORIA
      field: "NombreTipoProducto",
      header: "Sub Categoría",
      headerEn: "SubCategory",
      className: "small",
    },
    {
      // MONEDA
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "Xsmall",
      align: "center",
    },
    {
      // UNIDAD
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      body: (rowData) => rowData.UnitName,
      align: "center",
    },
    {
      // AGENTE
      field: "UserNameAgente",
      header: "Agente",
      className: "small",
    },
    {
      // ORDENADO
      field: "Quantity",
      header: "Ordenado",
      headerEn: "Order",
      className: "Xsmall",
      body: (rowData) => rowData.Quantity,
      Format: "Decimal",
      Sumary: "sum",
    },
    {
      // RECEIVE
      field: "QtyReceive",
      header: "Recibido",
      headerEn: "Received",
      className: "Xsmall",
      Format: "Decimal",
      sortable: true,
      Sumary: "sum",
    },
    {
      // BALANCE
      field: "Balance",
      header: "Balance",
      className: "Xsmall",
      body: (rowData) => rowData.Balance,
      Format: "Decimal",
      Sumary: "sum",
    },
    {
      // PRECIO
      field: "UnitPrice",
      header: "Precio",
      headerEn: "Price",
      className: "Xsmall",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
      //   Sumary: 'sum',
    },
    // SUBTOTAL
    {
      field: "SubTotal",
      header: "Subtotal",
      className: "small",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
      Sumary: "sum",
    },

    // DESCUENTO
    {
      field: "Discount",
      header: "Descuento",
      headerEn: "Discount",
      className: "Xsmall",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
      Sumary: "sum",
    },
    // ISV
    {
      field: "TAX",
      header: "TAX",
      headerEn: "ISV",
      className: "Xsmall",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
      Sumary: "sum",
    },
    // TOTAL
    {
      field: "Total",
      header: "Total",
      className: "small",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
      Sumary: "sum",
    },
  ];

  const tableOrdenes = {
    Columns: columnOrdenes,
    Data: dataOrdenes,
    loading: loading,
    selected: selectedDetalle,
    setSelected: setSelectedDetalle,
    showModal: (e) => showModal(e),
  };

  const tableDetalle = {
    Columns: columnDetalle,
    Data: dataDetalle,
    loading: loading,
    selected: selectedDetalle,
    setSelected: setSelectedDetalle,
    showModal: (e) => showModal(e),
  };

  const actualizarCompras = async () => {
    setLoading(true);
    const d = getDatesProduccion(dates);
    const t = await getListadoOrdenes(d);
    const dd = await getListadoDetalleOrdenes(d);
    setDataOrdenes(t);
    setDataDetalle(dd);
    setLoading(false);
  };
  
  const actualizarRequisasScreen = async () => {
    setLoading(true);
    const d = getDatesProduccion(dates);
    const t = await getRequisasDetalle(d);
    setDetalles(t);
    setLoading(false);
  };

  const items = [
    {
      label: "Español",
      icon: "pi pi-file-pdf",
      command: () => {
        setLanguaje("es");
        setShowReporte(true);
      },
    },
    {
      label: "Inglés",
      icon: "pi pi-file-pdf",
      command: () => {
        setLanguaje("en");
        setShowReporte(true);
      },
    },
  ];

  const showModal = (tipoModal) => {
    if (tipoModal === 'ordenCompra') {
      setOrdenDialog(true); 
    } else if (tipoModal === 'requisa') {
      setRequisaDialog(true); 
    } else {
      console.error('Tipo de modal no válido');
    }
  };

  const OrdenC = (Id) => {
    setOrderToShow(Id);
    setOrdenDialog(true);
    showModal('ordenCompra'); 
  };
  
  const RequisaC = (Id) => {
    setRequisaToShow(Id);
    setRequisaDialog(true)
    showModal('requisa'); 
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && orderToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setRequisaDialog(null);
          setOrdenDialog(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setRequisaDialog(null);
      setOrdenDialog(null);
      setHabilitar(true);
    }
  };

  const cerrarConfirmacion2 = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar1 && requisaToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setRequisaDialog(null);
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setRequisaDialog(null);
      setHabilitar1(true);
    }
  };

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "ordenes", config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <ModalFull
        header="Orden de compras"
        visible={ordenDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        contenido={
          <OrdenesComprasCrud
            PurchaseOrder={orderToShow}
            setOrderToShow={setOrderToShow}
            ordenDialog={ordenDialog}
            setOrdenDialog={setOrdenDialog}
            actualizarComprasScreen={actualizarCompras}
            setRequisaDialog={setRequisaDialog}
            setRequisaToShow={setRequisaToShow}
            infoScreen={getInfo}
            habilitar={habilitar}
            setHabilitar={setHabilitar}
          />
        }
      />

      <ModalFull
        header="Requisas Compras"
        visible={requisaDialog}
        onHide={(e) => {
          cerrarConfirmacion2();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
        contenido={
          <CrudRequisa
            idRequisa={requisaToShow}
            requisaDialog={requisaDialog}
            setRequisaDialog={setRequisaDialog}
            actualizarRequisasScreen={actualizarRequisasScreen}
            setOrdenDialog={setOrdenDialog}
            setOrderToShow={setOrderToShow}
            habilitar={habilitar1}
            setHabilitar={setHabilitar1}
          />
        }
      />

      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "ordenes", config.language)}</h3>
            {/* <CalendarWeek
              date={dates}
              setDate={setDates}
              loading={loading}
              buscar={getInfo}
              selectionMode="range"
            /> */}
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button icon={"pi pi-refresh"} onClick={(e) => {getInfo()}} />
            <Button icon={"pi pi-plus"} onClick={(e) => {showModal("ordenCompra");  setOrderToShow(null)}} />
            <Button
              icon="pi pi-print"
              tooltip="Imprimir"
              onClick={(e) => {
                if (selectedDetalle.length === 0) {
                  toastShow(toast, "warn", "Advertencia", "Seleccione una órden a imprimir");
                  return;
                }

                if (selectedDetalle.length > 20) {
                  toastShow(toast, "warn", "Advertencia", "Solo se imprimirán las primeras 20 órdenes.");
                }

                menuImprimir.current.toggle(e);
              }}
            />
            <Menu model={items} popup ref={menuImprimir} />

          </div>
        }
        contenido={
          <div className="pt-4">
            <TabView>
              <TabPanel header={"Detalle"}>
                <div className="pt-4" style={{ height: "83vh" }}>
                  <AgGrid table={tableDetalle} />
                </div>
              </TabPanel>
              <TabPanel header={"Ordenes"}>
                <div className="pt-4" style={{ height: "83vh" }}>
                  <AgGrid table={tableOrdenes} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        } 
      />


      {showReporte && (
        <OrdenesComprasReporte1
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selectedDetalle={selectedDetalle.slice(0, 20)}
          setSelectedDetalle={setSelectedDetalle}
          Language={Languaje}
          setLanguaje={setLanguaje}
        />
      )}
    </div>
  );
};

export default OrdenesComprasScreen;
